import { createDateObject } from "../../../../common/Functions";

export const getFilteredAddData = async (state) => {
  let currently_working = false;
  let sales = false;
  let contact_employer = false;
  let irb = false;
  let individual_life = false;
  let individual_annuity = false;
  let individual_disability = false;
  let individual_longterm = false;
  let full_time_role = false;
  let training = false;
  let training_start_date = "";
  let training_end_date = "";
  let subsidy = "";
  let db_end_date = "";

  if (state.currently_working === "Y") {
    currently_working = true;
  }
  if (state.sales === "Y") {
    sales = true;
  }
  if (state.contact_employer === "Y") {
    contact_employer = true;
  }
  if (state.irb === "Y") {
    irb = true;
  }
  if (state.individual_life === "Y") {
    individual_life = true;
  }
  if (state.individual_annuity === "Y") {
    individual_annuity = true;
  }
  if (state.individual_disability === "Y") {
    individual_disability = true;
  }
  if (state.individual_longterm === "Y") {
    individual_longterm = true;
  }
  if (state.full_time_role === "Y") {
    full_time_role = true;
  }
  if (state.training === "Y") {
    training = true;
  }
  if (
    state.training_start_date !== "" &&
    state.training_start_date !== "Invalid date"
  ) {
    training_start_date = createDateObject(state.training_start_date);
  }
  if (
    state.training_end_date !== "" &&
    state.training_end_date !== "Invalid date"
  ) {
    training_end_date = createDateObject(state.training_end_date);
  }
  if (state.subsidy !== "" && state.subsidy !== null) {
    subsidy = state.subsidy.replaceAll(",", "");
  }
  if (state.employment_end_date !== "") {
    db_end_date = createDateObject(state.employment_end_date);
  }

  let data = {
    companyname: state.company_name,
    jobtitle: state.title,
    startdate: createDateObject(state.employment_start_date),
    enddate: db_end_date,
    currentemployer: currently_working,
    salesposition: sales,
    empphonenumber: state.contact_phone,
    contactemployer: contact_employer,
    empaddress1: state.street_address,
    empaddress2: state.address2,
    reasonforleaving: state.reason_for_leaving,
    empcity: state.city,
    empstate: state.state,
    empzip: state.zip_code,
    empcountry: state.country,
    urbanization: state.urbanization,
    invrelatedbus: irb,
    solicitindlife: individual_life,
    solicitindannuity: individual_annuity,
    solicitinddisability: individual_disability,
    solicitindltc: individual_longterm,
    fulltime: full_time_role,
    trainingsubsidy: training,
    trainingstartdate: training_start_date,
    trainingenddate: training_end_date,
    totalsubsidyrecd: subsidy,
    industryid: state.industry_select_id,
  };

  return data;
};

export function getEmplExpValue(val) {
  if (val === null) {
    return null;
  }

  return val ? "Y" : "N";
}
